 <div tabindex="0">
    <span *ngFor="let val of value" class="searchable-value">
        <a *ngIf="isValidFieldCollectionValue(field, val)" 
           class="pointMe" 
           (click)="resultFieldSearch(field, val)" 
           [title]="val">
          {{!val ? "&nbsp" : val}}
        </a> 
        <span *ngIf="!isValidFieldCollectionValue(field, val)" [title]="val">
            {{val}}
        </span>
    </span>
 </div>